import { Box, chakra } from '@chakra-ui/react';

export const container = chakra(Box, {
    label: 'date-arrow-container',
    baseStyle: {
        paddingTop: '1.5rem',
        w: '36px'
    }
});
